"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.settings.title': 'Otwórz Ustawienia',
    'shortcuts.settings.description': 'Otwiera panel ustawień do konfiguracji preferencji',
};
